import { Box, Optional, Image } from '@honda-canada/design-system-react';
import React from 'react';
import themeStyles from './VehicleSummaryCard.styles';
import TrimDetails from '../TrimOverview/TrimDetails';
const VehicleImage = themeStyles.apply(Image, 'VehicleImage');
const ModelBadge = themeStyles.apply(Image, 'ModelBadge');
const BadgeWrapper = themeStyles.apply(Box, 'BadgeWrapper');
const FlexContainer = themeStyles.apply(Box, 'FlexContainer');
const VehicleSummaryCard = ({ vehicle, vehicleImage, bigExteriorImage, modelBadgeImage, badgeTestId }) => {
    var _a;
    return (React.createElement(FlexContainer, null,
        React.createElement(Optional, { when: bigExteriorImage },
            React.createElement(VehicleImage, { "data-testid": "cy-vehicle-image", src: bigExteriorImage, alt: vehicleImage === null || vehicleImage === void 0 ? void 0 : vehicleImage.alt })),
        React.createElement(BadgeWrapper, { "data-testid": badgeTestId },
            React.createElement(ModelBadge, { "data-testid": "cy-model-badge_image", src: modelBadgeImage === null || modelBadgeImage === void 0 ? void 0 : modelBadgeImage.src, alt: modelBadgeImage === null || modelBadgeImage === void 0 ? void 0 : modelBadgeImage.alt }),
            React.createElement(TrimDetails, { modelYear: vehicle.modelYear, trimName: vehicle.trimName, transmissionName: (_a = vehicle.transmission) === null || _a === void 0 ? void 0 : _a.transmissionName, align: "flex-start", size: "regular" }))));
};
export default VehicleSummaryCard;
